import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Cert = ({ title, subtitle, color = '#3B82F6' }) => (
  <div className="card-bg rounded-lg p-6 flex flex-col items-center text-center">
    <div className="relative w-24 h-24 mb-4">
      <div
        className="absolute inset-0 rounded-full flex items-center justify-center border-4"
        style={{
          borderColor: color,
          background: 'radial-gradient(circle at 50% 30%, rgba(255,255,255,0.06) 0%, rgba(10,14,26,0.6) 70%)',
        }}
      >
        <div className="text-center px-1">
          <p className="text-[7px] font-bold tracking-wider text-white uppercase" style={{ color }}>
            {subtitle}
          </p>
          <p className="text-[6px] tracking-wider mt-0.5 uppercase text-white/80">
            CERTIFIED
          </p>
          <p className="text-[7px] font-bold text-white leading-tight mt-1 uppercase">
            {title}
          </p>
          <div className="flex justify-center gap-0.5 mt-1" style={{ color }}>
            <span className="text-[8px]">★</span>
            <span className="text-[8px]">★</span>
          </div>
        </div>
      </div>
    </div>
    <p className="text-xs tracking-[0.3em] text-[#D4AF7A] font-semibold">{title}</p>
  </div>
);

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="section-bg py-28 border-t border-[rgba(232,200,136,0.08)]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <p className="dash-title mb-8">— {t.about.eyebrow} —</p>
        </div>

        <div className="lg:col-span-8">
          <div className="text-[#E8EAF0] text-lg lg:text-xl leading-[1.9] font-light text-justify">
            {t.about.body
              .replace(/(NIS2 regulations\.|NIS2\.)/, '$1\n\n')
              .split('\n\n')
              .map((paragraph, i) => (
                <p key={i} className={i > 0 ? 'mt-6' : ''}>{paragraph}</p>
              ))}
          </div>

          <div className="mt-10 pb-8">
            <p className="font-semibold text-[#E8EAF0] text-base mb-2">
              {t.about.subtitle}
            </p>
            <p className="text-[#9CA3AF] text-sm lg:text-base leading-relaxed font-light">
              {t.about.note}
            </p>
          </div>

          <div className="grid grid-cols-3 gap-4 lg:gap-6 mt-6">
            <Cert title="SC-300" subtitle="Microsoft" color="#5FA8E0" />
            <Cert title="AZ-104" subtitle="Microsoft" color="#5FA8E0" />
            <Cert title="SEC+" subtitle="CompTIA" color="#E85D5D" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
